export const DashboardType = {
    RailcarVolume: 'Railcar Volume',
    NetworkDwell: 'Dwell',
    CycleTime: 'Cycle Time',
    CompareContrast: 'Railstate Comparison',    
    EquipmentCount: 'Equipment Count',
    Shipments: 'Shipments',
    Deliveries: 'Deliveries',
    Landing: 'Landing'
};
